// import React, { Component } from "react";
// import {
//   Container,
//   Card,
//   CardHeader,
//   Button,
//   CardBody,
//   Row,
//   Table,
//   Col,
// } from "reactstrap";

// import { connect } from "react-redux";
// import { Link } from "react-router-dom";
// import moment from "moment";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import "../reports.scss";

// import SLE_logo from "../../../assets/images/SriLalitha_Logo.png";
// // import "../app-invoice.css";
// import { getRFQDocReport } from "../../../store/Reports/actions";
// import {
//   getQuotationsData,
//   getRFQRequestdata,
// } from "../../../store/CompareQuotation/actions";
// class RFQVendorWiseReportDocument extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {};
//   }

//   componentDidMount() {
//     // Use the same API calls as CompareQuotation to get quotation data
//     const rfqId = this.props.match.params.id;

//     // First get RFQ data, then quotations (like CompareQuotation does)
//     // this.props.getRFQRequestdata(rfqId);
//     this.props.getQuotationsData(rfqId);
//   }

//   getPDFReport = async () => {
//     const element = document.getElementById("toPdf");
//     if (!element) return;

//     const originalWidth = element.style.width;
//     element.style.width = "297mm";
//     element.style.maxWidth = "290mm";

//     const pdf = new jsPDF("landscape", "mm", "a4");
//     const pageWidth = pdf.internal.pageSize.getWidth();
//     const pageHeight = pdf.internal.pageSize.getHeight();

//     // Use a higher scale for better text clarity
//     const canvas = await html2canvas(element, {
//       scale: 1.5,
//       useCORS: true,
//       scrollX: 0,
//       scrollY: 0,
//       windowWidth: element.scrollWidth,
//       windowHeight: element.scrollHeight,
//     });

//     const imgData = canvas.toDataURL("image/png");
//     const imgWidth = pageWidth;
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;

//     let heightLeft = imgHeight;
//     let position = 0;

//     pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//     heightLeft -= pageHeight;

//     while (heightLeft > 0) {
//       position -= pageHeight;
//       pdf.addPage();
//       pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//       heightLeft -= pageHeight;
//     }

//     pdf.save("Request_For_Quotation_Vendor_Wise.pdf");

//     // Revert back to original
//     element.style.width = originalWidth;
//   };
//   reportBody() {
//     return (
//       <Row className="p-1 report-preview">
//         <Col md={12} className="p-1">
//           <Card className="p-1 report-preview-card">
//             <CardBody className="report-padding pb-0">
//               {/* HEADER */}
//               <div className="report-body d-flex align-items-center justify-content-between mt-0">
//                 {/* Empty left spacer */}
//                 <div style={{ width: "25%" }}></div>

//                 {/* CENTER TITLE */}
//                 <div style={{ width: "50%" }} className="text-center">
//                   <h3 className="card-title-16 pt-2 mb-0">
//                     SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
//                   </h3>
//                 </div>

//                 {/* RIGHT DATE */}
//                 <div style={{ width: "25%" }} className="text-right">
//                   <div className="report-wrapper">
//                     <p className="report-wrapper-title mb-0">Submitted On:</p>
//                     <p className="report-wrapper-det mb-0">
//                       {moment(this.props.RFQ_Doc_report.createdon).format(
//                         "DD-MM-YYYY"
//                       )}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               <hr className="hr-black-color" />
//               {this.renderComparisonTable && this.renderComparisonTable()}{" "}
//               {/* <div className=" card-title-14 mt-2  mb-0">
//                 <p>Vendors List</p>
//               </div> */}
//               <hr className="hr-black-color " />
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>
//     );
//   }

//   renderComparisonTable() {
//     const quotationData = this.props.CQbodyData || [];
//     const rfqCellData = this.props.RFQCellData || [];
//     const VENDORS_PER_PAGE = 2;

//     if (!quotationData.length) {
//       return (
//         <div className="text-center p-4">
//           <h5>No quotation data available</h5>
//         </div>
//       );
//     }

//     // ---------- BUILD VENDORS ----------
//     const allVendors = [];
//     rfqCellData.forEach((cell, index) => {
//       if (index !== 0 && cell.vendId) {
//         allVendors.push({
//           id: cell.vendId,
//           name: cell.headerName,
//           cellKey: cell.CellName,
//         });
//       }
//     });

//     // ---------- SPLIT INTO PAGES ----------
//     const vendorChunks = [];
//     for (let i = 0; i < allVendors.length; i += VENDORS_PER_PAGE) {
//       vendorChunks.push(allVendors.slice(i, i + VENDORS_PER_PAGE));
//     }

//     const rows = quotationData.filter((row) => row.ItemName);

//     return vendorChunks.map((vendors, pageIndex) => (
//       <div
//         key={pageIndex}
//         style={{
//           pageBreakAfter:
//             pageIndex === vendorChunks.length - 1 ? "auto" : "always",
//         }}
//       >
//         <Table
//           bordered
//           className="mb-4 table-centered table-color-black"
//           style={{ tableLayout: "fixed" }}
//         >
//           <thead className="bg-light text-center">
//             <tr>
//               <th rowSpan={2}>S.NO</th>
//               <th rowSpan={2} style={{ width: "260px" }}>
//                 DESCRIPTION
//               </th>
//               <th rowSpan={2}>UOM</th>
//               <th rowSpan={2}>QTY</th>

//               {vendors.map((vendor) => (
//                 <th key={vendor.id} colSpan={6}>
//                   {vendor.name}
//                 </th>
//               ))}
//             </tr>

//             <tr>
//               {vendors.map((vendor) => (
//                 <React.Fragment key={vendor.id}>
//                   <th>MAKE</th>
//                   <th>RATE</th>
//                   <th>DISC %</th>
//                   <th>DISC VALUE</th>
//                   <th>TAX</th>
//                   <th>VALUE</th>
//                 </React.Fragment>
//               ))}
//             </tr>
//           </thead>

//           <tbody>
//             {rows.map((row, idx) => {
//               const item = row.ItemName;

//               return (
//                 <tr key={item.rfqItemId}>
//                   <td className="text-center">{idx + 1}</td>

//                   <td style={{ wordBreak: "break-word" }}>
//                     <b>{item.Name}</b>
//                     <div className="text-muted">{item.description || "-"}</div>
//                   </td>

//                   <td className="text-center">{item.Quantity_unit?.name}</td>
//                   <td className="text-center">{item.Quantity}</td>

//                   {vendors.map((vendor) => {
//                     const vData = row[vendor.cellKey] || {};

//                     return (
//                       <React.Fragment key={vendor.id}>
//                         <td>{vData.make || "-"}</td>
//                         <td>
//                           {vData.baseprice
//                             ? `₹ ${Number(vData.baseprice).toFixed(2)}`
//                             : "-"}
//                         </td>
//                         <td>
//                           {vData.discountpercent
//                             ? `${vData.discountpercent}%`
//                             : "-"}
//                         </td>
//                         <td>{vData.discount ? `₹ ${vData.discount}` : "-"}</td>
//                         <td>
//                           {vData.taxtype === 1
//                             ? "Inclusive"
//                             : vData.taxtype === 2
//                             ? "Exclusive"
//                             : "-"}
//                         </td>

//                         <td className="text-center">
//                           {Number(vData?.updateGrossValue) > 0
//                             ? `₹ ${Number(
//                                 vData.updateGrossValue
//                               ).toLocaleString()}`
//                             : vData?.GrossValue
//                             ? `₹ ${Number(vData.GrossValue).toLocaleString()}`
//                             : "-"}
//                         </td>
//                       </React.Fragment>
//                     );
//                   })}
//                 </tr>
//               );
//             })}

//             {/* TOTALS */}
//             <tr className="compare-total-row">
//               <td colSpan={4}>
//                 <b>Total</b>
//               </td>
//               {vendors.map((v) => (
//                 <td key={v.id} colSpan={6} className="text-center">
//                   ₹ {this.props.CQVendorTotals?.[v.id]?.total || 0}
//                 </td>
//               ))}
//             </tr>

//             <tr className="compare-gst-row">
//               <td colSpan={4}>
//                 <b>GST</b>
//               </td>
//               {vendors.map((v) => (
//                 <td key={v.id} colSpan={6} className="text-center">
//                   ₹ {this.props.CQVendorTotals?.[v.id]?.gst || 0}
//                 </td>
//               ))}
//             </tr>

//             <tr className="compare-grandtotal-row">
//               <td colSpan={4}>
//                 <b>Grand Total</b>
//               </td>
//               {vendors.map((v) => (
//                 <td key={v.id} colSpan={6} className="text-center">
//                   ₹ {this.props.CQVendorTotals?.[v.id]?.grand_total || 0}
//                 </td>
//               ))}
//             </tr>
//           </tbody>
//         </Table>
//       </div>
//     ));
//   }

//   render() {
//     return (
//       <React.Fragment>
//         <div className="page-content">
//           <Container fluid>
//             <Row>
//               <Col md={12}>
//                 <Card>
//                   <CardHeader className="bg-transparent border-bottom no-print ">
//                     <Link
//                       to="#"
//                       onClick={() => this.props.history.goBack()}
//                       className="action-icon text-primary mr-2"
//                     >
//                       <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
//                     </Link>
//                     {/* {this.props.rfqPDF ? (
//                       <Link
//                         // to="/rfqdashboard"
//                         onClick={() => this.props.history.goBack()}
//                         className="action-icon text-primary mr-2"
//                       >
//                         <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
//                       </Link>
//                     ) : (
//                       <Link
//                         to="/rfqreport"
//                         className="action-icon text-primary mr-2"
//                       >
//                         <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
//                       </Link>
//                     )} */}
//                     <div className="float-right">
//                       <div className="d-inline-block ">
//                         <Button
//                           type="button"
//                           outline
//                           color="secondary"
//                           className=" mr-2"
//                           onClick={() => this.getPDFReport()}
//                         >
//                           <i className="ri-file-excel-2-line"></i>
//                           <span className="d-none d-inline-block ml-1">
//                             PDF
//                           </span>
//                         </Button>

//                         <Button
//                           type="button"
//                           outline
//                           color="secondary"
//                           className=" mr-2"
//                           onClick={() => {
//                             window.focus();
//                             window.print();
//                           }}
//                         >
//                           <i className="mdi  mdi-printer"></i>
//                           <span className="d-none d-inline-block ml-1">
//                             Print
//                           </span>
//                         </Button>
//                       </div>
//                     </div>
//                   </CardHeader>
//                   <CardBody
//                     className="pt-1 mr-auto mx-auto"
//                     id="toPdf"
//                     // style={{ width: "297mm" }}
//                   >
//                     {this.reportBody()}
//                   </CardBody>
//                 </Card>
//               </Col>
//             </Row>
//           </Container>
//         </div>
//       </React.Fragment>
//     );
//   }
// }

// const mapStatetoProps = (state) => {
//   const { RFQ_Doc_report, rfqPDF } = state.reports;
//   const { RFQCellData, CQbodyData, RFQrowdata, CQVendorTotals } =
//     state.CompareQuotation;
//   return {
//     RFQ_Doc_report,
//     rfqPDF,
//     RFQCellData,
//     CQbodyData,
//     RFQrowdata,
//     CQVendorTotals,
//   };
// };

// export default connect(mapStatetoProps, {
//   getRFQDocReport,
//   getQuotationsData,
//   getRFQRequestdata,
// })(RFQVendorWiseReportDocument);

import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Col,
} from "reactstrap";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../reports.scss";

import SLE_logo from "../../../assets/images/SriLalitha_Logo.png";
import { getRFQDocReport } from "../../../store/Reports/actions";
import {
  getQuotationsData,
  getRFQRequestdata,
} from "../../../store/CompareQuotation/actions";

class RFQVendorWiseReportDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const rfqId = this.props.match.params.id;
    this.props.getQuotationsData(rfqId);
  }

  getPDFReport = async () => {
    const element = document.getElementById("toPdf");
    if (!element) return;

    const pdf = new jsPDF("landscape", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    // Save original body/container styles
    const prevBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "visible";

    // Unlock ALL divs
    const allDivs = element.querySelectorAll("div");
    const prevDivStyles = [];
    allDivs.forEach((div) => {
      prevDivStyles.push({
        el: div,
        overflow: div.style.overflow,
        overflowX: div.style.overflowX,
        width: div.style.width,
        maxWidth: div.style.maxWidth,
      });
      div.style.overflow = "visible";
      div.style.overflowX = "visible";
      div.style.maxWidth = "none";
      div.style.width = "auto";
    });

    // Unlock tables
    const allTables = element.querySelectorAll("table");
    const prevTableStyles = [];
    allTables.forEach((t) => {
      prevTableStyles.push({ el: t, width: t.style.width });
      t.style.width = "auto";
    });

    // Wait for reflow
    await new Promise((resolve) => setTimeout(resolve, 300));

    const fullWidth = element.scrollWidth;
    const fullHeight = element.scrollHeight;

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      scrollX: 0,
      scrollY: -window.scrollY,
      windowWidth: fullWidth,
      windowHeight: fullHeight,
      width: fullWidth,
      height: fullHeight,
    });

    // Restore everything
    document.body.style.overflow = prevBodyOverflow;
    prevDivStyles.forEach(({ el, overflow, overflowX, width, maxWidth }) => {
      el.style.overflow = overflow;
      el.style.overflowX = overflowX;
      el.style.width = width;
      el.style.maxWidth = maxWidth;
    });
    prevTableStyles.forEach(({ el, width }) => {
      el.style.width = width;
    });

    // Build PDF pages
    const imgData = canvas.toDataURL("image/png");
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position -= pageHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save("RFQ_Vendor_Wise_Report.pdf");
  };

  renderComparisonTable() {
    const quotationData = this.props.CQbodyData || [];
    const rfqCellData = this.props.RFQCellData || [];

    const VENDORS_PER_ROW = 4;

    if (!quotationData.length) {
      return (
        <div className="text-center p-4">
          <h5>No quotation data available</h5>
        </div>
      );
    }

    // Build vendor list
    const allVendors = [];
    rfqCellData.forEach((cell, index) => {
      if (index !== 0 && cell.vendId) {
        allVendors.push({
          id: cell.vendId,
          name: cell.headerName,
          cellKey: cell.CellName,
        });
      }
    });

    // Chunk vendors into groups of 4
    const vendorChunks = [];
    for (let i = 0; i < allVendors.length; i += VENDORS_PER_ROW) {
      vendorChunks.push(allVendors.slice(i, i + VENDORS_PER_ROW));
    }

    const rows = quotationData.filter((row) => row.ItemName);

    return (
      <>
        {vendorChunks.map((vendors, chunkIndex) => (
          <div key={chunkIndex} style={{ marginBottom: "32px" }}>
            {/* Chunk label */}
            <p className="mb-1 text-muted" style={{ fontSize: "12px" }}>
              Vendors {chunkIndex * VENDORS_PER_ROW + 1}–
              {Math.min((chunkIndex + 1) * VENDORS_PER_ROW, allVendors.length)}{" "}
              of {allVendors.length}
            </p>

            {/* ── Horizontal scroll wrapper ── */}
            <div style={{ overflowX: "auto", width: "100%" }}>
              <Table
                bordered
                className="mb-0 table-centered table-color-black"
                style={{
                  tableLayout: "auto", // columns size to content
                  width: "max-content", // table grows as wide as needed
                  fontSize: "11px",
                  whiteSpace: "nowrap", // NO vertical wrapping anywhere
                }}
              >
                <thead className="bg-light text-center">
                  <tr>
                    <th rowSpan={2} style={{ minWidth: "40px" }}>
                      S.NO
                    </th>
                    <th
                      rowSpan={2}
                      style={{
                        width: "200px",
                        minWidth: "200px",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      }}
                    >
                      DESCRIPTION
                    </th>
                    <th rowSpan={2} style={{ minWidth: "60px" }}>
                      UOM
                    </th>
                    <th rowSpan={2} style={{ minWidth: "50px" }}>
                      QTY
                    </th>

                    {vendors.map((vendor) => (
                      <th
                        key={vendor.id}
                        colSpan={6}
                        style={{ textAlign: "center", minWidth: "420px" }}
                      >
                        {vendor.name}
                      </th>
                    ))}
                  </tr>

                  <tr>
                    {vendors.map((vendor) => (
                      <React.Fragment key={vendor.id}>
                        <th style={{ minWidth: "70px" }}>MAKE</th>
                        <th style={{ minWidth: "80px" }}>RATE</th>
                        <th style={{ minWidth: "60px" }}>DISC %</th>
                        <th style={{ minWidth: "80px" }}>DISC VALUE</th>
                        <th style={{ minWidth: "70px" }}>TAX</th>
                        <th style={{ minWidth: "70px" }}>VALUE</th>
                      </React.Fragment>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {rows.map((row, idx) => {
                    const item = row.ItemName;
                    return (
                      <tr key={item.rfqItemId}>
                        <td className="text-center">{idx + 1}</td>
                        <td
                          style={{
                            width: "200px",
                            minWidth: "200px",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            verticalAlign: "top",
                          }}
                        >
                          <b>{item.Name}</b>
                          <div
                            className="text-muted"
                            style={{ fontSize: "10px" }}
                          >
                            {item.description || "-"}
                          </div>
                        </td>

                        <td
                          className="text-center"
                          style={{ verticalAlign: "middle" }}
                        >
                          {item.Quantity_unit?.name}
                        </td>
                        <td
                          className="text-center"
                          style={{ verticalAlign: "middle" }}
                        >
                          {item.Quantity}
                        </td>

                        {vendors.map((vendor) => {
                          const vData = row[vendor.cellKey] || {};
                          return (
                            <React.Fragment key={vendor.id}>
                              <td style={{ verticalAlign: "middle" }}>
                                {vData.make || "-"}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {vData.baseprice
                                  ? `₹ ${Number(vData.baseprice).toFixed(2)}`
                                  : "-"}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {vData.discountpercent
                                  ? `${vData.discountpercent}%`
                                  : "-"}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {vData.discount ? `₹ ${vData.discount}` : "-"}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {vData.taxtype === 1
                                  ? "Inclusive"
                                  : vData.taxtype === 2
                                    ? "Exclusive"
                                    : "-"}
                              </td>
                              <td
                                className="text-center"
                                style={{ verticalAlign: "middle" }}
                              >
                                {Number(vData?.updateGrossValue) > 0
                                  ? `₹ ${Number(vData.updateGrossValue).toLocaleString()}`
                                  : vData?.GrossValue
                                    ? `₹ ${Number(vData.GrossValue).toLocaleString()}`
                                    : "-"}
                              </td>
                            </React.Fragment>
                          );
                        })}
                      </tr>
                    );
                  })}

                  {/* ── TOTALS ── */}
                  <tr className="compare-total-row">
                    <td colSpan={4}>
                      <b>Total</b>
                    </td>
                    {vendors.map((v) => (
                      <td key={v.id} colSpan={6} className="text-center">
                        ₹ {this.props.CQVendorTotals?.[v.id]?.total || 0}
                      </td>
                    ))}
                  </tr>

                  <tr className="compare-gst-row">
                    <td colSpan={4}>
                      <b>GST</b>
                    </td>
                    {vendors.map((v) => (
                      <td key={v.id} colSpan={6} className="text-center">
                        ₹ {this.props.CQVendorTotals?.[v.id]?.gst || 0}
                      </td>
                    ))}
                  </tr>

                  <tr className="compare-grandtotal-row">
                    <td colSpan={4}>
                      <b>Grand Total</b>
                    </td>
                    {vendors.map((v) => (
                      <td key={v.id} colSpan={6} className="text-center">
                        ₹ {this.props.CQVendorTotals?.[v.id]?.grand_total || 0}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </Table>
            </div>
            {/* ── end scroll wrapper ── */}
          </div>
        ))}
      </>
    );
  }

  reportBody() {
    return (
      <Row className="p-1 report-preview">
        <Col md={12} className="p-1">
          <Card className="p-1 report-preview-card">
            <CardBody className="report-padding pb-0">
              {/* HEADER */}
              <div className="report-body d-flex align-items-center justify-content-between mt-0">
                <div style={{ width: "25%" }} />
                <div style={{ width: "50%" }} className="text-center">
                  <h3 className="card-title-16 pt-2 mb-0">
                    SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                  </h3>
                </div>
                <div style={{ width: "25%" }} className="text-right">
                  <div className="report-wrapper">
                    <p className="report-wrapper-title mb-0">Submitted On:</p>
                    <p className="report-wrapper-det mb-0">
                      {moment(this.props.RFQ_Doc_report?.createdon).format(
                        "DD-MM-YYYY",
                      )}
                    </p>
                  </div>
                </div>
              </div>

              <hr className="hr-black-color" />
              {this.renderComparisonTable()}
              <hr className="hr-black-color" />
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print">
                    <Link
                      to="#"
                      onClick={() => this.props.history.goBack()}
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20" />
                    </Link>
                    <div className="float-right">
                      <div className="d-inline-block">
                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className="mr-2"
                          onClick={() => this.getPDFReport()}
                        >
                          <i className="ri-file-pdf-line" />
                          <span className="d-none d-inline-block ml-1">
                            PDF
                          </span>
                        </Button>
                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className="mr-2"
                          onClick={() => {
                            window.focus();
                            window.print();
                          }}
                        >
                          <i className="mdi mdi-printer" />
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>

                  <CardBody className="pt-1 mr-auto mx-auto" id="toPdf">
                    {this.reportBody()}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { RFQ_Doc_report, rfqPDF } = state.reports;
  const { RFQCellData, CQbodyData, RFQrowdata, CQVendorTotals } =
    state.CompareQuotation;
  return {
    RFQ_Doc_report,
    rfqPDF,
    RFQCellData,
    CQbodyData,
    RFQrowdata,
    CQVendorTotals,
  };
};

export default connect(mapStatetoProps, {
  getRFQDocReport,
  getQuotationsData,
  getRFQRequestdata,
})(RFQVendorWiseReportDocument);
